import React, { useState, useEffect } from "react";
import {
  Card,
  List,
  Button,
  Spin,
  Typography,
  message,
  Modal,
  Upload,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import IdCard from "../components/modal/IdCard";
import Get from "../services/Get";
import { useNavigate } from "react-router-dom";
import Post from "../services/Post";

const { Title } = Typography;

const Member = () => {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [qrData, setQrData] = useState(null);
  const [logo, setLogo] = useState(null);
  const [selectedMember, setSelectedMember] = useState(null);
  const [isQrModalOpen, setIsQrModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [students, setStudents] = useState([]);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [uploadingStudent, setUploadingStudent] = useState(null);
  const [file, setFile] = useState(null);
  const [imageBase64, setImageBase64] = useState();

  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setUser(parsedUser);

      if (parsedUser.member_type === "parent") {
        getStudents(parsedUser.id);
      } else {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  }, []);

  const getStudents = (parentId) => {
    Get.getStudentList(parentId)
      .then((res) => {
        setStudents(res.data);
      })
      .catch((error) => {
        message.error(error.message || "Failed to load students.");
      })
      .finally(() => setLoading(false));
  };

  const showCard = (item) => {
    setLoading(true);
    Get.getSingleMember(item.id)
      .then((res) => {
        setProfile(res.profile);
        setQrData(res.qr_code);
        setLogo(res.logo);
        setSelectedMember(res.data);
        setIsQrModalOpen(true);
      })
      .catch((error) => {
        message.error(error.message || "Failed to fetch member details.");
      })
      .finally(() => setLoading(false));
  };

  const showStudentCard = (item) => {
    console.log('function called');
    setLoading(true);
    
    Get.getSingleStudent(item.id)
      .then((res) => {
        setProfile(res.profile);
        setQrData(res.qr_code);
        setLogo(res.logo);
        setSelectedMember(res.data);
        console.log(res.data.school.address);
        setIsQrModalOpen(true);
      })
      .catch((error) => {
        console.error(error);
        message.error(error.message || "Failed to fetch student details.");
      })
      .finally(() => setLoading(false));
  };

  const handleUpload = (id) => {
    if (!imageBase64) {
      message.error("Please select an image to upload.");
      return;
    }

    const studentData = {
      profile: imageBase64, // Send base64 image data
    };

    setLoading(true);

    Post.UpdateStudentProfile(id, studentData)
      .then((res) => {
        if (res.error) {
          message.error(res.error);
        } else {
          message.success("Student profile updated successfully!");
          setIsUploadModalOpen(false);
          getStudents(user.id); // Refresh student list
        }
      })
      .catch((err) => {
        console.error(err);
        message.error("Failed to upload profile image.");
      })
      .finally(() => {
        setLoading(false);
      });

    setImageBase64("");
    setFile(null);
  };

  const handleFileChange = (file) => {
    console.log("here");
    const reader = new FileReader();
    reader.readAsDataURL(file); // Read file as base64
    console.log(reader);

    reader.onload = () => {
      const base64String = reader.result.split(",")[1]; // Extract base64 data
      console.log(base64String);
      setImageBase64(base64String);
    };

    setFile(file.originFileObj);
    return false; // Prevent default upload behavior
  };

  if (loading) {
    return (
      <div
        style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}
      >
        <Spin size="large" />
      </div>
    );
  }

  if (!user) {
    return (
      <p style={{ textAlign: "center", marginTop: "20px" }}>
        No user data found
      </p>
    );
  }

  return (
    <div style={{ maxWidth: "600px", margin: "auto", marginTop: "40px" }}>
      {user.member_type === "parent" ? (
        <Card
          title="Student List"
          bordered={false}
          style={{ boxShadow: "0 4px 8px rgba(0,0,0,0.1)" }}
        >
          {students.length > 0 ? (
            <List
              dataSource={students}
              renderItem={(student, index) => (
                <List.Item
                  key={index}
                  style={{ padding: "10px 20px" }}
                  actions={[
                    <Button
                      type="primary"
                      className="form-btn"
                      onClick={() =>
                        student.student.profile === "default.png"
                          ? (setUploadingStudent(student.student),
                            setIsUploadModalOpen(true))
                          : showStudentCard(student.student)
                      }
                    >
                      {student.student.profile === "default.png"
                        ? "Upload Profile"
                        : "View ID Card"}
                    </Button>,
                    <Button
                      type="default"
                      onClick={() =>
                        navigate("/user/attendance-calendar", {
                          state: { id: student.student.id, type: "student" },
                        })
                      }
                    >
                      View Attendance
                    </Button>,
                  ]}
                >
                  <List.Item.Meta
                    title={student.student.name}
                    description={`Class: ${student.student.class}-${student.student.section} | Admission no ${student.student.admission_no}`}
                  />
                </List.Item>
              )}
            />
          ) : (
            <p style={{ textAlign: "center", color: "gray" }}>
              No students found
            </p>
          )}
        </Card>
      ) : (
        <Card
          title={`Welcome ${user.name}`}
          bordered={false}
          style={{
            textAlign: "center",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          }}
        >
          <Button
            type="primary"
            style={{ margin: "10px" }}
            className="form-btn"
            onClick={() => showCard(user)}
          >
            Get ID Card
          </Button>
          <Button
            type="default"
            style={{ margin: "10px" }}
            onClick={() =>
              navigate("/user/attendance-calendar", {
                state: { id: user.id, type: user.member_type },
              })
            }
          >
            View Attendance
          </Button>
        </Card>
      )}

      {/* ID Card Modal */}
      {/* <IdCard
        isModalOpen={isQrModalOpen}
        setIsModalOpen={setIsQrModalOpen}
        title="Member ID Card"
        profile={profile}
        candidateName={selectedMember?.name}
        studentClass={selectedMember?.class}
        studentSection={selectedMember?.section}
        studentAdmission={selectedMember?.admission_no}
        displayNumber={selectedMember?.qr_no}
        qrData={qrData}
        logo={logo}
      /> */}

      {user.member_type === "parent" ? (
        <IdCard
          isModalOpen={isQrModalOpen}
          setIsModalOpen={setIsQrModalOpen}
          title={"Student ID Card"}
          profile={profile}
          candidateName={selectedMember?.name}
          studentClass={selectedMember?.class}
          studentSection={selectedMember?.section}
          studentAdmission={selectedMember?.admission_no}
          displayNumber={selectedMember?.qr_no}
          fathersName={selectedMember?.parent.name}
          schoolName={selectedMember?.school.name}
          mobile={selectedMember?.parent.mobile}
          schoolMobile={selectedMember?.school.mobile}
          schoolAddress={selectedMember?.school.address}
          cardType={selectedMember?.school.card_type}
          qrData={qrData}
          logo={logo}
        />
      ) : (
        <IdCard
          isModalOpen={isQrModalOpen}
          setIsModalOpen={setIsQrModalOpen}
          title="Member ID Card"
          profile={profile}
          candidateName={selectedMember?.name}
          displayNumber={selectedMember?.qr_no}
          qrData={qrData}
          logo={logo}
        />
      )}

      {/* Upload Profile Modal */}
      <Modal
        title="Upload Profile Picture"
        open={isUploadModalOpen}
        onCancel={() => setIsUploadModalOpen(false)}
        footer={[
          <Button key="cancel" onClick={() => setIsUploadModalOpen(false)}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={() => handleUpload(uploadingStudent.id)}
            className="form-btn"
          >
            Submit
          </Button>,
        ]}
      >
        <Upload accept="image/*" beforeUpload={handleFileChange} maxCount={1}>
          <Button icon={<UploadOutlined />}>Select Image</Button>
        </Upload>
      </Modal>
    </div>
  );
};

export default Member;
